import { Router } from '@angular/router';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';

import { HomePageService } from './../home-page/home-page.service';
import { AppService } from '../app.service';
import * as json from '../data/lista.json';


@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
        openCennikListBool = false;
    openDealersListBool = false;
    dealers: any = [];
    @ViewChild('toggler', { static: false }) toggler: ElementRef;
    @ViewChild('togglerBtn', { static: false }) togglerBtn: ElementRef;

    constructor(
        public homePageService: HomePageService,
        private appService: AppService,
        private renderer: Renderer2,
        private router: Router
    ) {
        this.dealers = (json as any).default;
        this.dealers.sort((a: any, b: any) => a.miasto.localeCompare(b.miasto));
    }

    openCennikList() {
        this.openCennikListBool = true;
    }
    closeCennikList() {
        this.openCennikListBool = false;
    }

    openDealersList() {
        this.openDealersListBool = true;
    }
    closeDealersList() {
        this.openDealersListBool = false;
    }

    hideMobileNav() {
        this.renderer.removeClass(this.toggler.nativeElement, 'show');
        this.renderer.addClass(this.toggler.nativeElement, 'hide');
        this.renderer.setAttribute(this.togglerBtn.nativeElement, 'aria-expanded', 'false');
        // this.renderer.addClass(this.togglerBtn.nativeElement, 'hide');
    }

    pushDataLayer(eventName, eventLabel, eventCategory) {
        this.appService.sendGaData(eventName, eventLabel, eventCategory);
    }

    sendGaEvent(event, eventLabel, eventCategory) {
        this.appService.sendGaData(event, eventLabel, eventCategory);
    }

    scrollToNagrody() {
        // const input = document.getElementById('inputFormOffer');
        // input.scrollIntoView({ behavior: "smooth", block: "start" });
        const input = document.getElementById('sectionRewards');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
    }

    scrollToform() {
        // const input = document.getElementById('inputFormOffer');
        // input.scrollIntoView({ behavior: "smooth", block: "start" });
        const input = document.getElementById('sectionOfferForm');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
    }
}

